import { render, staticRenderFns } from "./AppMobileFooter.vue?vue&type=template&id=e40b4180"
import script from "./AppMobileFooter.vue?vue&type=script&lang=js"
export * from "./AppMobileFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonTelephoneCall: require('/home/forge/ab.farescraper.com/components/ButtonTelephoneCall.vue').default})
